




































































































import { Component, Prop, Emit, Vue } from 'vue-property-decorator'

@Component
export default class Modal extends Vue {
  @Emit('close')
  closeModal () {}
}
